export default __webpack_public_path__ + "static/media/modal_1_wood_mobile_es.fb985694.svg";